module.exports = __webpack_public_path__ + "static/media/03.19dd3ce4.png";